//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

//algolia full text search
import { algolia } from 'assets/algolia';

// html parser
import Parser from 'html-react-parser';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import CustomSelect from "components/Select/Select.jsx";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ConfirmDialog from "components/ConfirmDialog/ConfirmDialog.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Mail from "@material-ui/icons/MailOutline";
import Receipt from "@material-ui/icons/Receipt";

import Add from "@material-ui/icons/AddShoppingCart";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}
  
class OrderDetails extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      order: { items: [], notes: "", status: ""},
      address: { street:"", city:"", state:"" },
      addresses: [],
      tax: 0.00,
      addingNew: false,
      productIDQuery: "",
      productNameQuery: "",
      baselineOrder: {
        items: []
      },
      orderChanged: false,
      searchResults:[],
      searchInProgress: false,
      pricing:[],
      school:{},
      shipToAddress: { name:"", address:"", city:"", state:"", zip:""}
    };

    this.addNew = this.addNew.bind(this);
    this.changeAddress = this.changeAddress.bind(this);
    this.searchProductIDs = this.searchProductIDs.bind(this);
    this.searchProductNames = this.searchProductNames.bind(this);
  }

  handleClickOpen(modal) {

    console.log(this.props);
    
    this.setState({order: this.props.order}, () => {

      this.getBaselineOrder();
      this.getShippingAddress();
      
      if(this.state.order.tax) {
        this.setState({tax: this.state.order.tax});
      }

      var x = [];
      x[modal] = true;
      this.setState(x);
    });
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }
    
  trim(value, maxLength) {
    if(value.length > maxLength)
        return value.substring(0,maxLength) + "...";
    else
        return value;
  }

  getBaselineOrder() {

    var baselineOrder = {
      items: [],
      shippingAddressID: this.state.order.shippingAddressID
    }
    
    for(var i = 0; i < this.state.order.items.length; i++) {
      baselineOrder.items.push(
        {
          productID: this.state.order.items[i].productID, 
          qty: this.state.order.items[i].qty, 
          listPrice: this.state.order.items[i].listPrice
        }
      );
    }

    this.setState({baselineOrder});
  }

  checkOrderChanged() {
    
    var changed = false;

    var order = this.state.order;
    var baseline = this.state.baselineOrder;

    if(baseline.shippingAddressID !== order.shippingAddressID) {
      changed = true;
    } else if(baseline.items.length !== order.items.length) {
      changed = true;
    } else {
      for(var i = 0; i < baseline.items.length; i++) {
        var isFound = false;
        for(var j = 0; j < order.items.length; j++) {
          if(baseline.items[i].productID === order.items[j].productID) {
            isFound = true;
            
            if(baseline.items[i].qty !== order.items[j].qty ||
               baseline.items[i].listPrice !== order.items[j].listPrice) {
                changed = true;
            
                break;
              }
          }
        }
        if(!isFound) {
          changed = true;
          break;
        }
      }
    }

    this.setState({orderChanged: changed});
  }

  getShippingAddress() {

    db.getSchool(this.state.order.schoolID).then((school) => {
      console.log(school)

      this.setState({
        school: school,
        shipToAddress: {
          name: school.Name,
          address: school.Address,
          city: school.City,
          state: school.State,
          zip: school.PostalCode
        }}, () => {
        this.calculateTax();
      });
    });

  }
  

  getNotes() {
    var notes = this.state.order.notes;
    while(notes.indexOf('\n') > -1) {
      notes = notes.replace('\n','<br>')
    }
    
    return Parser(notes)
  }

  calculateTax() {

    this.calculateTotal();
  }

  updateOrder(property, value) {
    var x = this.state.order;
    x[property] = value;
    this.setState({order: x});
  }

  calculateTotal() {
 
    var x = this.state.order;

    var total = 0.00;
    for(var i = 0; i < x.items.length; i++) {

      if(!isNaN(x.items[i].qty) && !isNaN(x.items[i].listPrice)) {
        x.items[i].total = (Number(x.items[i].qty) * Number(x.items[i].listPrice)).toFixed(2);
      } else {
        x.items[i].total = 0.00;
      }
      total = (Number(total) + Number(x.items[i].total)).toFixed(2);
    }

    x.orderTotal = (Number(total) + Number(this.state.tax)).toFixed(2);
    this.setState({order: x}, () => {
      this.checkOrderChanged();
    });
  }

  addNew() {
    this.setState({addingNew: true});
  }

  showAddNew() {
    if(this.state.addingNew) {
      return "table-row";
    } else {
      return "none";
    }
  }

  showAddNewButton() {
    if(this.state.addingNew) {
      return "none";
    } else {
      return "block";
    }
  }

  addLineItem(item) {

    var x = this.state.order;
    x.items.push(item);
    this.setState({order: x});
  }

  updateLineItem(id, property, value) {
    var x = this.state.order;

    for(var i = 0; i < x.items.length; i++) {

      if(x.items[i].id === id)
        x.items[i][property] = value;
      }

    this.setState({order: x}, () => {
      this.calculateTax();
    });
  }

  deleteLineItem(id) {

    var x = this.state.order;

    for(var i = 0; i < x.items.length; i++) {

      if(x.items[i].id === id) {
        x.items.splice(i,1);
        break;
      }    
    }

    this.setState({order: x});
    this.calculateTax();
  }

  setSearchProductIDsTimer(query) {
    clearTimeout(this.searchProductIDs);
    this.setState({productIDQuery: query}, () => {
        setTimeout(this.searchProductIDs,1700);
    });
  }

  searchProductIDs() {

    algolia.getProductsByID(this.state.productIDQuery).then(results => {

      if(results.length > 0) {
        if(results[0].productID.toLowerCase() === this.state.productIDQuery.toLowerCase()) {

          var lineItem = {
            id: results[0].id,
            name: results[0].name,
            listPrice: results[0].listPrice,
            qty: 1,
            productID: results[0].productID,
            total: Number(results[0].listPrice).toFixed(2)
          }
  
          this.addLineItem(lineItem);
          this.setState({addingNew: false, productIDQuery: ""});
        }
      }
    });
  }

  setSearchProductNamesTimer(query) {
    clearTimeout(this.searchProductNames);
    this.setState({productNameQuery: query}, () => {
        setTimeout(this.searchProductNames,1700);
    });
  }

  searchProductNames() {
    algolia.getProductsByName(this.state.productNameQuery).then(results => {
      this.setState({searchResults: results, searchInProgress: true });
    });
  }

  addProduct(product) {

    var lineItem = {
      id: product.id,
      name: product.name,
      listPrice: product.listPrice,
      qty: 1,
      productID: product.productID,
      total: Number(product.listPrice).toFixed(2)
    }

    this.addLineItem(lineItem);
    this.setState({addingNew: false, productNameQuery: "", searchInProgress: false, orderChanged: true});
  }

  showSearchResults() {
    if(this.state.searchInProgress) {
      return "block";
    } else {
      return "none";
    }
  }

  changeAddress(id) {
    
    var x = this.state.order;
    x.shippingAddressID = id;
    this.setState({order: x});

    this.checkOrderChanged();
  }

  sendToVendor() {
    var promises = [];
    var items = this.state.order.items;

    for(var i = 0; i < items.length; i++) 
      promises.push(db.getProduct(items[i].id));
    
    Promise.all(promises).then((dbResults) => {
      
      var filtered = [];

      for(var j = 0; j < dbResults.length; j++) {
        for(var k = 0; k < items.length; k++) {
          if(dbResults[j].id === items[k].id) {
            if(Number(dbResults[j].CategoryID) === 1) {
              items[k].cost = dbResults[j].Cost;
              items[k].total = (Number(items[k].qty) * Number(items[k].cost)).toFixed(2) ;
              filtered.push(items[k]);
              break;
            }
          }
        }
      }

      this.sendNotifications("michael@allthingseq.com", filtered);
      this.sendNotifications("emailsevans@gmail.com", filtered);
      //this.sendNotifications("danna@allthingseq.com", filtered);
    });
  }

  sendNotifications(email, items) {
    
    var html = '<html>';
    html = html + 'A new All Things EQ order was placed for ' + this.state.shipToAddress.name + '.';
    
    html = html + '<br /><br />';
    html = html + '<b>Shipping Address</b><br />';
    if(this.state.shipToAddress.name)
      if(this.state.shipToAddress.name.length > 0)
        html = html + this.state.shipToAddress.name + "<br />";
    html = html + this.state.shipToAddress.address + "<br />";
    html = html + this.state.shipToAddress.city + ", " + this.state.shipToAddress.state + " " + this.state.shipToAddress.zip + "<br />";

    html = html + '<br />';

    html = html + '<table style="width:100%" cellpadding="6">';
    html = html + '<tr>';
    html = html + '<td><b>QTY</b></td>';  
    html = html + '<td><b>SKU</b></td>';  
    html = html + '<td><b>Name</b></td>';  
    html = html + '<td><b>Price</b></td>';
    html = html + '<td><b>Total</b></td>';  
    html = html + '</tr>';

    var total = 0.00;

    for(var i = 0; i < items.length; i++) {
      html = html + '<tr>';
      html = html + '<td>' + items[i].qty + '</td>';  
      html = html + '<td>' + items[i].sku + '</td>'; 
      html = html + '<td>' + items[i].name + '</td>';  
      html = html + '<td>$' + items[i].cost + '</td>';  
      html = html + '<td>$' + items[i].total + '</td>';  
      html = html + '</tr>';

      total = total + (Number(items[i].qty) * Number(items[i].cost)); 
    }
    html = html + '</table>';

    html = html + '<br />';
    html = html + '<div style="fontWeight:600;">Order Total: ' + total.toFixed(2) + '</div>';  
    html = html + '<br />';
    html = html + '';
    html = html + '</html>';
    
    // admin Email
    
    const adminEmail = {
      email: email,
      subject: 'New Order: ' + this.state.shipToAddress.name,
      body: html
    }

    fetch("https://us-central1-keiki-262db.cloudfunctions.net/sendEmail", {
        method: "POST", 
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(adminEmail)
      })
      .then((response) => {
          
          if(response.ok) {
              return response.json();
          } else {
            console.log("error (1): ");  
            console.log(response);
          }

          
      })
      .catch((error) => {
          // If there is any error you will catch them here
          console.log("error (2):  " + error);
          
      });
  }

  saveOrder() {
    db.updateOrder(this.state.order.id, this.state.order).then(() => {
      this.props.orderChanged(this.state.order);
      this.handleClose("modal");
    });
  }

  render() {

    const { classes } = this.props;

    return (
      <div>
        
        <IconButton
          aria-label="Edit"
          onClick={() => this.handleClickOpen("modal")}>
          <Edit className={ classes.tableActionButtonIcon + " " + classes.edit } />
        </IconButton>
        <Dialog
          classes={{
            root: classes.center,
            paper: classes.modal
          }}
          maxWidth="md"
          fullWidth
          open={this.state.modal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleClose("modal")}
          aria-labelledby="modal-slide-title"
          aria-describedby="modal-slide-description">

          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
            style={{backgroundColor:"#efefef"}} >

            <GridContainer direction="row">
              <GridItem xs={12} sm={12} md={6}>
                <h4 className={classes.modalTitle}>Order Details</h4>
              </GridItem>
              <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                
              </GridItem>
            </GridContainer>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
            style={{backgroundColor:"#efefef"}}>
            <CustomTabs
              headerColor="success"
              tabs={[
                {
                  tabName: "General",
                  tabIcon: Receipt,
                  tabContent: (
                    
                      <GridContainer direction="row" style={{minHeight:"369px"}}>
                        <GridItem xs={3}>
                          <br />
                          <b>Order</b><div style={{fontWeight:400}}>
                            {this.state.order.id}<br />
                            <span style={{color:"#3fa31b"}}>{this.state.order.orderPlaced}</span>
                          </div>
                        </GridItem>
                        <GridItem xs={3}>
                          <br />
                          <b>Customer</b><div style={{fontWeight:400}}>
                            {this.state.school.Name}<br />
                            <span style={{color:"#3fa31b"}}>{this.state.order.userName}</span><br />
                            PO#: {this.state.order.poNumber}
                          </div>
                        </GridItem>
                        <GridItem xs={3}>
                          <br />
                          <b>Shipping Address</b><div style={{fontWeight:400}}>
                          {this.state.shipToAddress.address}<br />
                          {this.state.shipToAddress.city} {this.state.shipToAddress.state} {this.state.shipToAddress.zip}
                          </div>
                        </GridItem>
                        <GridItem xs={3}>
                          <CustomSelect
                            id="status"
                            labelText="Status"
                            value={this.state.order.status}
                            inputProps={{
                                placeholder: "Status"
                            }}
                            formControlProps={{
                                fullWidth: true
                            }}
                            onChange={(e) => this.updateOrder("status", e.target.value)}
                            options={[
                              {key:"QUOTE",label:"Quote"},
                              {key:"APPROVED",label:"Approved"},
                              {key:"VENDOR",label:"Sent To Vendor(s)"},
                              {key:"COMPLETE",label:"Complete"}
                            ]}
                            />
                        </GridItem>
                        <GridItem xs={12}>
                          <br />
                          <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{padding:"0px", width:"50px"}}></TableCell>
                                    <TableCell style={{padding:"3px"}}>
                                        Name
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        Qty
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        Price
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        Total
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.order.items.map((value, index) => (
                                <TableRow key={index}>
                                    <TableCell style={{padding:"0px", width:"50px"}}>
                                      <Tooltip id="tooltip-top-start" title="Delete Line Item" placement="top" classes={{ tooltip: classes.tooltip }} >
                                        <ConfirmDialog header="Confirm Delete" description="Are you sure you want to delete this product? This action cannot be undone." confirmed={() => this.deleteLineItem(value.id)} />
                                      </Tooltip>
                                    </TableCell>
                                    <TableCell style={{padding:"3px"}}>
                                        {this.trim(value.name,54)}
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"50px" }}>
                                      <input type="text" value={value.qty} placeholder="qty" 
                                        onChange={(e) => this.updateLineItem(value.id, "qty", e.target.value)} 
                                        style={{
                                          borderStyle:"none", 
                                          backgroundColor:"#efefef", 
                                          padding:"6px", 
                                          height:"21px", 
                                          borderRadius:"6px", 
                                          fontSize:"12px", 
                                          width:"90%", 
                                          textAlign:"right",
                                          marginLeft:"3px",
                                          marginRight:"3px",
                                        }} />
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"80px" }}>
                                      <input type="text" value={value.listPrice} placeholder="price" 
                                        onChange={(e) => this.updateLineItem(value.id, "listPrice", e.target.value)} 
                                        style={{
                                          borderStyle:"none", 
                                          backgroundColor:"#efefef", 
                                          padding:"6px", 
                                          height:"21px", 
                                          borderRadius:"6px", 
                                          fontSize:"12px", 
                                          width:"90%", 
                                          textAlign:"right",
                                          marginLeft:"3px",
                                          marginRight:"3px",
                                        }}  />
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        ${value.total}
                                    </TableCell>
                                </TableRow>
                                ))}
                                <TableRow style={{display:this.showAddNew()}}>
                                    <TableCell style={{padding:"0px", width:"50px"}}>
                                      <IconButton onClick={this.addLineItem} style={{color:"green"}}>
                                          <Add />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell style={{padding:"3px"}}>
                                      <input type="text" placeholder="Product ID" className={classes.modalTextBox} style={{textAlign:"left"}}
                                          onChange={(e) => this.setSearchProductIDsTimer(e.target.value)} value={this.state.productIDQuery} />
                                    </TableCell>
                                    <TableCell style={{padding:"3px", position: "relative"}}>
                                      <input type="text" placeholder="Product Name" className={classes.modalTextBox} style={{textAlign:"left"}} 
                                        onChange={(e) => this.setSearchProductNamesTimer(e.target.value)} value={this.state.productNameQuery} />
                                      <div id="divSearchResults" style={{position: "absolute", height:"120px", width:"100%", backgroundColor:"#efefef", borderRadius:"6px", marginLeft:"6px", overflow:"auto", padding:"10px", fontSize:"11px", border:"solid 1px green", display:this.showSearchResults()}} >
                                        {this.state.searchResults.map((value, index) => (
                                          <div key={index} style={{cursor:"pointer", color:"232323"}} 
                                            onClick={() => this.addProduct(value)}><span style={{color:"green"}}>{value.productID}</span> - {this.trim(value.name,54)}</div>
                                        ))}
                                      </div>
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"50px" }}>
                                      <input type="text" placeholder="Qty" className={classes.modalTextBox} style={{display:"none"}} />
                                    </TableCell>
                                    <TableCell style={{padding:"6px", width:"80px" }}>
                                      <input type="text" placeholder="Price" className={classes.modalTextBox} style={{display:"none"}} />
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        $0.00
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={{padding:"0px", width:"50px"}}>
                                      <IconButton onClick={this.addNew} style={{display:this.showAddNewButton()}}>
                                          <Add />
                                      </IconButton>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        <b>Tax</b>
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        <b>${this.state.tax.toFixed(2)}</b>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        <b>Total</b>
                                    </TableCell>
                                    <TableCell style={{padding:"3px", textAlign:'right'}}>
                                        <b>${this.state.order.orderTotal}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                          </Table>
                        </GridItem>
                        <GridItem xs={12}>
                          <br />
                          <b>Notes</b><div style={{fontWeight:400}}>
                            {this.getNotes()}
                          </div>
                        </GridItem>
                      </GridContainer>
                  )
                },
              ]}
            />

          </DialogContent>
          
          <DialogActions
            className={classes.modalFooter }
            style={{backgroundColor:"#efefef"}}>

              <GridContainer>
                <GridItem xs={6}>

                </GridItem>
                <GridItem xs={6} style={{textAlign:"right"}}>
                  <Button onClick={() => this.sendToVendor()} >
                    <Mail /> Send To Vendor
                  </Button>
                  &nbsp;
                  <Button onClick={() => this.handleClose("modal")} >
                    Close
                  </Button>
                  &nbsp;
                  <Button color="success" onClick={() => this.saveOrder()} >
                    Save
                  </Button>
                </GridItem>
              </GridContainer>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

OrderDetails = connect(mapStateToProps)(OrderDetails);
export default withStyles(modalStyle)(OrderDetails);


// WEBPACK FOOTER //
// ./src/components/OrderDetails/OrderDetails.jsx